import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";
import { useNavigate } from "react-router-dom";
const TestHistory = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const UID = user?.UID;

  useEffect(() => {
    
    if (!UID) return;

    const fetchHistory = async () => {
      try {
        const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_LIST_OF_TEST_JOIN}`;

        const res = await fetch(path, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ UID }),
        });

        const data = await res.json();

        if (data.res === "Success") {
          setTests(data.data);
        }
      } catch (err) {
        console.error("Test history error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [UID]);

const handleCardClick = (test) => {
  navigate("/test-review", {
    state: {
      TEST_ID: test.TEST_ID,
      TEST_NAME: test.TEST_NAME
    }
  });
};

  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      <div
  className="container"
  style={{
    paddingTop: "90px",
    height : "auto"
  }}
>
        <h3 className="text-center mb-4">📜 Test History</h3>

        {loading && (
          <div className="text-center">
            <div className="spinner-border text-primary"></div>
          </div>
        )}

        {!loading && tests.length === 0 && (
          <p className="text-center text-muted">
            No test history found
          </p>
        )}

        <div className="row">
          {tests.map((test, index) => {
            const percentage = (
              (test.Total_right / test.Total_attempt) *
              100
            ).toFixed(2);

            return (
              <div className="col-md-6 col-lg-4 mb-4" key={index}>
                <div
                  className="card h-100 shadow-sm cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardClick(test)}
                >
                  <div className="card-header bg-primary text-white">
                    {test.TEST_NAME}
                  </div>

                  <div className="card-body">
                    <p><b>Date:</b> {test.TEST_DATE}</p>
                    <p><b>Time:</b> {test.TEST_TIME}</p>

                    <hr />

                    <p className="mb-1">Total Questions: {test.Total_attempt}</p>
                    <p className="text-success mb-1">
                      Correct: {test.Total_right}
                    </p>
                    <p className="text-danger mb-1">
                      Wrong: {test.Total_wrong}
                    </p>

                    <p className="fw-bold">
                      Score: {percentage}%
                    </p>
                  </div>

                  <div className="card-footer text-center text-muted">
                    Click to view details →
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default TestHistory;
